export default {"src":"/_next/static/media/LogoDark.70d5d14e.svg","height":24,"width":76,"blurWidth":0,"blurHeight":0};